
import { defineComponent } from 'vue';
import { VueFinalModal } from 'vue-final-modal';

import Image from '@hems/component/src/image/Image.vue';

export default defineComponent({
  name: 'ModalContainer',
  components: {
    VueFinalModal,
    Image,
  },
  props: {
    modalContentClass: {
      type: String,
      default: '',
    },
    isCloseButton: {
      type: Boolean,
      default: true,
    },
  },
});
